
import { Button } from "@windmill/react-ui";
import { ChangePage } from '../../store/reducers/menu';
import { dispatch } from '../../store';
import useApi from '../../hooks/useApi';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { Logout } from '../../store/reducers/auth';

const AccountCloseModal = () => {

    const Api = useApi();
    const { user } = useSelector((state) => state.auth);

    const confirmClose = () => {
        dispatch(ChangePage(""))
        Api.closeAccount({ userId: user?._id }).then(({ data }) => {
            if (data.status) {
                toast.success(data.msg)
                setTimeout(() => {
                    dispatch(Logout({}))
                }, 500);
            } else {
                toast.error(data.msg)
            }
        })
    }

    return (
        <div id="confirm-modal"
            tabIndex={-1}
            style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
            aria-hidden="true"
            className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen"
            data-modal-backdropclasses="bg-yellow-700">
            <div className="relative rounded-lg shadow w-full max-w-md dark:bg-black">
                <button
                    type="button"
                    className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    data-modal-hide="login-modal"
                    onClick={() => {
                        dispatch(ChangePage(""))
                    }}
                >
                    <svg
                        className="w-3 h-3"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 14"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                        />
                    </svg>
                    <span className="sr-only">Close modal</span>
                </button>
                <div className="px-6 py-6 lg:px-8">
                    <h1 className="text-white">Account Close</h1>
                    <div className="flex flex-col mt-4">
                        <p className="text-[25px] text-white text-center mt-5">Are you sure?</p>
                        <p className="text-sm text-white text-center mt-5">Your account will be closed.</p>
                        <p className="text-sm text-white text-center mt-2">You won't be able to access to your account anymore!</p>
                    </div>
                    <div className="flex mt-4 w-full mt-[10%] gap-5">
                        <Button
                            disabled={false}
                            layout="primary"
                            className='w-full'
                            onClick={confirmClose}
                        >
                            Yes
                        </Button>
                        <Button
                            disabled={false}
                            layout="primary"
                            className='w-full'
                            onClick={() => {
                                dispatch(ChangePage(""))
                            }}
                        >
                            No
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AccountCloseModal;
